var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimelineDot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 633187"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    opacity: 0.1,
    cx: 19.5039,
    cy: 19.5,
    r: 19.5,
    transform: "rotate(-90 19.5039 19.5)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    opacity: 0.2,
    cx: 19.6427,
    cy: 19.4569,
    r: 12.4572,
    transform: "rotate(-90 19.6427 19.4569)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    opacity: 0.3,
    cx: 19.6427,
    cy: 19.4559,
    r: 9.34289,
    transform: "rotate(-90 19.6427 19.4559)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 19.6427,
    cy: 19.457,
    r: 6.2286,
    transform: "rotate(-90 19.6427 19.457)",
    fill: "#686868"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineDot);
export default __webpack_public_path__ + "static/media/timeline_dot.43bdf341aedbef33054da5bc671cf0a0.svg";
export { ForwardRef as ReactComponent };